import { api } from "@/lib/api";

import type {
  CreateSaleReq,
  Sale,
  SaleChannel,
  SaleList,
  SalePaymentStatus,
  UpdateSaleReq,
} from "@artisancode/api-types";

export interface SaleListParams {
  page?: number;
  per_page?: number;
  q?: string;
  channel?: SaleChannel;
  payment_status?: SalePaymentStatus;
  date_from?: string;
  date_to?: string;
  workspace_id?: string;
}

export const saleService = {
  list: (params?: SaleListParams) =>
    api.get<SaleList>(
      "/sales",
      params as Record<string, string | number | boolean | undefined>,
    ),

  create: (body: CreateSaleReq, idempotencyKey?: string) =>
    api.post<Sale>(
      "/sales",
      body,
      idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    ),

  update: (id: string, body: UpdateSaleReq) =>
    api.put<Sale>(`/sales/${id}`, body),

  delete: (id: string, reason: string) => api.del(`/sales/${id}`, { reason }),

  void: (id: string, reason: string) =>
    api.post<Sale>(`/sales/${id}/void`, { reason }),
};
